export default function CustomLoader({
  message = "Loading...",
  className = "",
  size = 50, 
  color = "green", 
  animationSpeed = "1s", 
}) {
  return (
    <div className={`flex justify-start items-center p-5 rounded-3xl w-full ${className}`}>
      <div className="flex items-center gap-6">
        {/* Loader Container */}
        <div className="relative flex justify-center items-center" style={{ width: size, height: size }}>
          
          {/* Outer Expanding Waves */}
          <div
            className="absolute rounded-full animate-ping"
            style={{
              width: size,
              height: size,
              backgroundColor: `green`, 
              animationDuration: animationSpeed,
            }}
          ></div>
          
          <div
            className="absolute rounded-full animate-ping"
            style={{
              width: size * 1.2, 
              height: size * 1.2,
              backgroundColor: `${color}20`,
              animationDuration: animationSpeed,
              animationDelay: "0.2s",
            }}
          ></div>

          <div
            className="absolute rounded-full animate-ping"
            style={{
              width: size * 1.4,
              height: size * 1.4,
              backgroundColor: `${color}10`,
              animationDuration: animationSpeed,
              animationDelay: "0.4s",
            }}
          ></div>

          {/* Spinning Circle (Inner Loader) */}
          <div
            className="border-4 border-t-transparent rounded-full animate-spin"
            style={{
              width: size * 0.6,
              height: size * 0.6,
              borderColor: color,
              borderTopColor: "transparent",
              animationDuration: animationSpeed,
            }}
          ></div>
        </div>

        {/* Loading Text */}
        <p className={`text-${color}-700 text-xl font-bold tracking-wide`}>{message}</p>
      </div>
    </div>
  );
}
